/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-12-12 17:19:48
 * @Description: 协议
 */
"use strict";
angular.module("agreementModule", []).
controller("agreementCtrl", ["$scope", "$modalInstance", "content","$state", function($scope, $modalInstance, content,$state) {
    initStatus();

    function initStatus() {
        $scope.status = {
            switch: 'picture'
        }
        $scope.platformName = '目号平台';
//      $scope.platformName = '通讯员平台';
    };
    $scope.content = content;
    $scope.confirm = function() {
        $modalInstance.close($scope.abc);

        if(content.chose == 0){
            var orgUrlName = "register.basicinformation";
            var param = content.chose;
            $state.go(orgUrlName,{userType:param});
        }else{
            var orgUrlName = "register.basicinformation";
            var param = content.chose;
            $state.go(orgUrlName,{userType:param});
        }
    };
    $scope.cancel = function() {
        $modalInstance.dismiss();
    };
    $scope.switch = function(type) {
        $scope.status.switch = type;
        $scope.switchMain = $scope.status.switch;
    };
}]);
